import { createSlice } from "@reduxjs/toolkit";

export const comLangueSlice = createSlice(
    {
    name : "ComLangue",
    initialState: {
        langue: "FON"
    },
    reducers: {
        // action : {type: '', payload : tout ce qu'on veut}
        sendLangue : (state, action) => {
        state.langue = action.payload
        }       
    }
})